import { createAsyncTypes } from 'utils/ActionCreator'

const BASE_TYPE = 'EmailEncryption/EmailTracking'

export const FETCH_TRACKED_EMAILS_ASYNC = createAsyncTypes('FETCH_TRACKED_EMAILS', BASE_TYPE)
export const FETCH_TRACKED_EMAILS_SUMMARY_ASYNC = createAsyncTypes(
  'FETCH_TRACKED_EMAILS_SUMMARY',
  BASE_TYPE
)
export const FETCH_TRACKED_EMAIL_DETAIL_ASYNC = createAsyncTypes(
  'FETCH_TRACKED_EMAIL_DETAIL',
  BASE_TYPE
)
export const CHANGE_MESSAGE_ACCESS_ASYNC = createAsyncTypes('CHANGE_MESSAGE_ACCESS', BASE_TYPE)

export const SET_TRACKED_EMAILS_FILTERS = `${BASE_TYPE}/SET_FILTERS`
export const GO_TO_TRACKED_EMAILS_NEXT_PAGE = `${BASE_TYPE}/NEXT_PAGE`
export const GO_TO_TRACKED_EMAILS_PREV_PAGE = `${BASE_TYPE}/PREV_PAGE`
export const CLEAR_TRACKED_EMAIL_DETAIL = `${BASE_TYPE}/CLEAR_EMAIL_DETAIL`

export const FETCH_TRIGGER_POLICIES_SCHEMA_ASYNC = createAsyncTypes(
  'FETCH_TRIGGER_POLICIES_SCHEMA',
  BASE_TYPE
)
export const FETCH_TRIGGER_POLICIES_CONFIG_ASYNC = createAsyncTypes(
  'FETCH_TRIGGER_POLICIES_CONFIG',
  BASE_TYPE
)

export const ELECTIVE_TRIGGER_VALUE = 'elective'

export const DEFAULT_TRACKED_EMAILS_PAGE_SIZE = 50
